import * as React from "react";
import {
    User,
    UserAchievementInfo,
} from "../../../../generated/protocol";
import {UserService, USER_SERVICE_NAME} from "../../../service/admin/UserService";
import {
    WalletService,
    WALLET_SERVICE_NAME,
    WalletBalanceResult,
    PokWalletAccounts
} from "../../../service/admin/WalletService";
import {AccountBalances} from "../../user/AccountBalances";
import {UserAchievements} from "../../user/UserAchievements";
import {UserItems} from "../../user/UserItems";
import {UserLevel} from "../../user/UserLevel";
import {UserActions} from "../../user/UserActions";
import {AppCtx} from "../../../ioc/ApplicationContext";
import {LoadingViewState, RouterView} from "../RouterView";
import {AchievementsService} from "../../../service/achievements/AchievementsService";
import {Symbols} from "../../../ioc/Symbols";
import {UserTransactionPanel} from "../../user/UserTransactionPanel";
import {OperatorService, OPERATOR_SERVICE_NAME} from "../../../service/admin/OperatorService";
import * as moment from "moment";
import {UserItemHistoryListView} from "./UserItemHistoryListView";
import {RUGPanel} from "../../attributes/RUGPanel";

interface State extends LoadingViewState {
    user?: User;
    accounts?: PokWalletAccounts;
    userAchievementInfo?: UserAchievementInfo;
    notFound?: boolean
}

export class UserView extends RouterView<{ params: { id: string } }, State> {

    userService: UserService;
    walletService: WalletService;
    achievementService: AchievementsService;
    operatorService: OperatorService;


    constructor(props) {
        super(props);
        this.userService = AppCtx.resolve<UserService>(USER_SERVICE_NAME);
        this.achievementService = AppCtx.resolve<AchievementsService>(Symbols.AchievementsService);
        this.walletService = AppCtx.resolve<WalletService>(WALLET_SERVICE_NAME);
        this.operatorService = AppCtx.resolve<OperatorService>(OPERATOR_SERVICE_NAME);
        this.state = {
            loading: true,
            user: null,
            accounts: {
                'sc-main': {walletBalance: '0.00', walletVersion: 0},
                'gc-main': {walletBalance: '0.00', walletVersion: 0},
                'sc-vault': {walletBalance: '0.00', walletVersion: 0},
                'gc-vault': {walletBalance: '0.00', walletVersion: 0},
            },
            userAchievementInfo: null,
        };
    }

    unMutePlayer(): Promise<void> {
        return this.userService.unMutePlayer(this.state.user.userId).then(user => {
            this.setState({user: user});
        });
    }

    mutePlayer(): Promise<void> {
        return this.userService.mutePlayer(this.state.user.userId).then(user => {
            this.setState({user: user});
        });
    }

    loadContent(): Promise<any> {
        var id = this.props.params.id;

        return Promise.all<any>([
            this.userService.getEntity(id),
        ]).then(values => {
            console.log("Values ", values);
            let user = values[0];
            if (!user) {
                this.setState({
                    notFound: true
                });
                return;
            }
            Promise.all<any>([
                this.achievementService.getUserAchievementInfo(id, user.operatorId),
                this.walletService.getBalancesV2(user.externalUserId),
            ]).then(values => {
                console.log("Achievements values ", values);
                this.setState({
                    loading: false,
                    user: user,
                    userAchievementInfo: values[0],
                    accounts: values[1],
                });
            });

        });
    }

    getAvatarUrl() {
        if (this.state.userAchievementInfo == null || !this.state.userAchievementInfo.items) {
            return null;
        }
        var items = this.state.userAchievementInfo.items.items;
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.category == "AVATAR" && item.equipped) {
                return item.imageUrl;
            }
        }
        return null;
    }

    getAvatar() {
        var avatarUrl = this.getAvatarUrl();
        if (avatarUrl == null) {
            let styles = {
                height: "130px",
                width: "130px",
                marginTop: "15px"
            };
            return (
                <img style={styles} src={`${contextPath}/images/avatar-5.png`} alt={"Avatar"}
                     className="img-circle circle-border m-b-md"/>
            )
        }


        var styles = {
            backgroundImage: 'url("' + avatarUrl + '")',
            height: "140px",
            width: "140px",
            backgroundSize: "280px 140px",
            margin: "15px auto"
        };
        return (
            <div className="img-circle circle-border m-b-md" style={styles}></div>

        );
    }

    renderContent() {
        if (this.state.notFound) {
            return (
                <div className="wrapper wrapper-content animated">
                    <div className="middle-box text-center fadeInDown">
                        <h2 className="font-bold danger">User does not exist.</h2>
                    </div>
                </div>)
        }
        let bgColor = "navy-bg";
        if (this.state.user.status == "BLOCKED") {
            bgColor = "red-bg";
        } else if (this.state.user.status == "REMOVED") {
            bgColor = "red-bg";
        }


        return (
            <div className="wrapper wrapper-content animated fadeInRight">
                <div className="row">

                    {/* Column 1 */}
                    <div className="col-md-12 col-lg-6">

                        <div className="row">
                            <div className="col-md-12" style={{marginBottom: "25px"}}>
                                <div style={{marginTop: "0px", width: "100%", display: "table", padding: "15px"}}
                                     className={"widget-head-color-box p-lg text-center " + bgColor}>
                                    <div className="col-xs-4">
                                        {this.getAvatar()}
                                    </div>
                                    <div className="col-xs-8">
                                        <div className="m-b-md" style={{textAlign: "left", marginTop: "4.5em"}}>
                                            <h2 className="font-bold no-margins">
                                                {this.state.user.attributes["externalUsername"] || this.state.user.attributes["screenname"] || this.state.user.userName}
                                            </h2>
                                            <h4>
                                                User ID: {this.state.user.userId}
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="widget-text-box">

                                    <table className="table m-b-xs table-striped">
                                        <tbody>
                                        <tr>
                                            <td width="30%">
                                                <strong> ID:</strong>
                                            </td>
                                            <td width="70%">
                                                {this.state.user.userId}

                                            </td>

                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>External ID:</strong>
                                            </td>
                                            <td>
                                                {this.state.user.externalUserId}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>Status:</strong>
                                            </td>
                                            <td>
                                                {this.state.user.status}

                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>Operator:</strong>
                                            </td>
                                            <td>
                                                {this.state.user.operatorId}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><strong>Created:</strong></td>
                                            <td>{moment(this.state.user.creationDate).tz("UTC").format("LLLL")}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>


                        <div className="row">
                            <AccountBalances cubeiaId={this.state.user.userId} accounts={this.state.accounts}/>
                        </div>

                        <div className="row">
                            <UserTransactionPanel
                                pokUserId={this.state.user.externalUserId}
                                credit={req => this.walletService.credit(req)}
                                debit={req => this.walletService.debit(req)}
                                onAdjustmentComplete={(account: string, balance: WalletBalanceResult) => {
                                    let newAccounts = {...this.state.accounts, [account]: balance};
                                    this.setState({accounts: newAccounts});
                                }}
                            />
                        </div>

                        <div className="row">
                            <UserActions user={this.state.user} onUnMutePlayer={this.unMutePlayer.bind(this)}
                                         onMutePlayer={this.mutePlayer.bind(this)}/>
                        </div>

                        <div className="row">
                            <UserLevel info={this.state.userAchievementInfo}/>
                        </div>

                        <div className="row">
                            <UserAchievements info={this.state.userAchievementInfo}/>
                        </div>

                        <div className="row">
                            <UserItems info={this.state.userAchievementInfo}/>
                        </div>

                    </div>

                    {/* Column 2 */}
                    <div className="col-md-12 col-lg-6">
                        <div className="row">
                            <div className="col-sm-12">
                                <UserItemHistoryListView params={{splat: "" + this.state.user.userId}}/>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <RUGPanel header="Related User Groups" attributes={this.state.user.attributes}
                                          user={this.state.user}/>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/ui/view/user/UserView.tsx